import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import * as _ from "lodash";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import {
  setSimpleFilterQuery,
  setAdvancedFilterQuery,
} from "../../utils/tableUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ProfessionalFuelService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getProfessionalFuel(
    locale: string,
    date: any,
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any,
    partyCode?: string
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    let body = {
      beginDate: date.startDate,
      endDate: date.endDate,
    };

    if (locale === "es") {
      body["partyCode"] = partyCode;
    }

    return this.http.post(this.buildDataUrl(locale, paging, "?"), body, {
      headers,
    });
  }

  getGenerateProfessionalFuel(
    locale: string,
    dates: any,
    partyCode?: string
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    let body = {
      beginDate: dates.startDate,
      endDate: dates.endDate,
    };

    if (locale === "es") {
      body["partyCode"] = partyCode;
    }

    return this.http.post(
      `${this.appSession.baseUrl}/api/v1/legal/${locale}/professionalFuel/generate`,
      body,
      { headers, responseType: "text" }
    );
  }

  
  getGenerateProfessionalFuelEs(
    dates: any,
    partyCode: string
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
      "Accept": "application/zip"
    });
    let body = {
      beginDate: dates.startDate,
      endDate: dates.endDate,
      partyCode: partyCode
    };

    return this.http.post(
      `${this.appSession.baseUrl}/api/v1/legal/es/professionalFuel/generate`,
      body,
      { headers, responseType: "blob" }
    );
  }

  private buildDataUrl(locale: string, pagingArgs: any, path: string): string {
    let baseQueryString = `${this.appSession.baseUrl}/api/v1/legal/${locale}/professionalFuel/preview${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = this._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
    baseQueryString += query;

    return baseQueryString;
  }

  private _buildScrollExpression(pagingArgs): string {
    const skip = pagingArgs.skip;
    const top = pagingArgs.top;
    const realSize = pagingArgs.realSize;

    if (top && top !== null) {
      return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
    } else {
      return `real_size=${!!realSize}&offset=${skip}`;
    }
  }
}
